
import * as type from '../../types/shop'

const reducer = (state = {}, action) => {
    switch (action.type) {
        case type.FETCH_SHOP_DETAIL:
            return action.payload
        default:
            return state
    }
}

export default reducer